//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.VehicleDesign.js";
import "../Features/Features.FeatureBuilder.js";
import "../no/Expression.js";
import "../no/ScCollector.js";
import "../no/Section.js";
import "../no/Expression.js";
import "../no/ScCollector.js";
import "../no/Section.js";
let d=[[[0,"AngularTolerance",1,0],[1,"ChordalTolerance",0,"Expression",0],[1,"CurveArcLength",0,"Expression",0],[1,"DashSurface",0,"ScCollector",0],[0,"DistanceTolerance",1,0],[0,"EyePoint",1,"Point",0],[0,"IsReflectData",1,0],[0,"IsReflectTraceCurve",1,0],[0,"IsRefractData",1,0],[0,"IsRefractTraceCurve",1,0],[0,"IsReverseReflectData",1,0],[0,"IsReverseReflectTraceCurve",1,0],[1,"ObstructionFace",0,"ScCollector",0],[0,"ReflectAccuracy",1,0],[1,"ReflectFace",0,"ScCollector",0],[0,"ReflectMethod",1,0],[1,"ReflectPoint",0,"Section",0],[1,"ReflectionObject",0,"ScCollector",0],[0,"ReflectionType",1,0],[0,"RefractionIndex",1,0],[0,"Resolution",1,0],[0,"ReverseDir",1,0],[1,"TargetObject",0,"Section",0],[0,"Thickness",1,1],[1,"ThicknessExp",0,"Expression",0]],[],[]];
SPLM.Features.VehicleDesign.ReflectionDataBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.VehicleDesign.ReflectionDataBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.VehicleDesign.ReflectionDataBuilder.ResolutionType = Object.freeze({
    "Low" : "Low", "Medium" : "Medium", "High" : "High", "Customized" : "Customized", "ByCurveArcLength" : "ByCurveArcLength", "ChordalTolerance" : "ChordalTolerance"});

SPLM.Features.VehicleDesign.ReflectionDataBuilder.ReflectMethodType = Object.freeze({
    "DirectReflect" : "DirectReflect", "ReverseReflection" : "ReverseReflection"});

SPLM.Features.VehicleDesign.ReflectionDataBuilder.ReflectObjectType = Object.freeze({
    "Point" : "Point", "Curve" : "Curve", "Face" : "Face"});

export default SPLM;